import React, { useState } from "react";
import { Container, Col, Row, Form, Button } from "react-bootstrap";
import { GoChevronRight } from "react-icons/go";
// import { useNavigate } from "react-router-dom";
import * as hireTopLevelTalentApi from "../../api/hireTopLevelTalentApi"
import { useSignalAbort } from "../../api/useSignalAbort";
import { ToastContainer,toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


function Lookingtohire() {
  // const navigate = useNavigate();
  const abortConstants = useSignalAbort()
  const [isHovered, setIsHovered] = useState(false);
  const [validated, setValidated] = useState(false);
  const [hireTopLevelTalentData, setHireTopLevelTalentData] = useState({Name:"",Email:"", Phone:"" , JobTitle:"", Description:""})


  const HireTopLevelTalent = async (data, abortToken) => {
    try {
      const result = await hireTopLevelTalentApi.HireTopLevelTalent(data, abortToken);
      console.log(result);
      // alert(result.data.message)
      toast.success( result.data.message,{
        autoClose: 5000, // Close the toast after 5 seconds
    });
      // Handle the result, maybe update state or perform other actions
    } catch (error) {
      console.error(error);
      // Handle the error, maybe update state or show an error message
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
   
    let newData = {
      Name: hireTopLevelTalentData.Name,
      Email: hireTopLevelTalentData.Email,
      Phone: hireTopLevelTalentData.Phone,
      JobTitle: hireTopLevelTalentData.JobTitle,
      Description: hireTopLevelTalentData.Description,
    };
    if (form.checkValidity() === false) {
      event.stopPropagation();
    }
    else {
      HireTopLevelTalent(newData, abortConstants.controllerConfig);
    }
    console.log(newData);
    setValidated(true);
  };

  const handleChange = (e) => {
    setHireTopLevelTalentData({ ...hireTopLevelTalentData, [e.target.name]: e.target.value })
  }

  const handleMouseOver = () => {
    setIsHovered(true);
  };

  const handleMouseOut = () => {
    setIsHovered(false);
  };

  const captionStyle = {
    textAlign: "center",
    padding: "2px",
  };

  const captionTextStyle = {
    fontSize: "2rem",
    fontWeight: "bold",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    marginTop: "2rem",
  };

  const captionTextStyleP = {
    fontSize: "1rem",
    marginTop: "1rem",
    textOverflow: "ellipsis",
    color: "black",
  };

  const buttonStyle = {
    fontSize: "12px",
    fontWeight: 600,
    textAlign: "center",
    alignItems: "center",
    border: "none",
    backgroundColor: isHovered ? "#F7F9FF" : "#FFE114",
    color: isHovered ? "black" : "black",
    transition:"background-color 0.5s ease-in-out, color 0.5s ease-in-out, transform 0.3s",
    transform: isHovered ? "translateX(10px)" : "translateX(0)",
  };
  const Buttoncolstyle = {
    marginTop: "30px",
    marginBottom: "30px",
    display: "flex",
    justifyContent: "center",
  };

  const formstyle = {
    width: "900px",
    marginBottom: "50px",
    padding: "20px",
  };
  // Additional styles for mobile screens
  const mobileCaptionTextStyle = {
    fontSize: "1.5rem",
    marginTop: "1rem",
  };
  const colstyle = {
    marginTop: "20px",
  };
  return (
    <Container
      fluid
      style={{ backgroundColor: "#F7F9FF", marginTop: "80px", height: "auto" }}
    >
      <Container style={{ padding: "2px" }}>
        <div style={captionStyle}>
          <h3 
            style={
              window.innerWidth <= 768
                ? mobileCaptionTextStyle
                : captionTextStyle
            }
          >
            Looking to hire top-level talent?
          </h3>
          <p style={captionTextStyleP}>
            Reach out, and a member of our team will contact you soon.
          </p>
        </div>
      </Container>
      <div className="d-flex justify-content-center" style={{ marginTop: "20px", marginBottom: "20px" }}>
        <Form
          style={formstyle}
          noValidate
          validated={validated}
          onSubmit={handleSubmit}
        >
          <Col xs={12} sm={12} md={12} lg={12} >
            <Row >
              <Col
                xs={12}
                sm={12}
                md={12}
                lg={6}
                style={{ marginBottom: "20px" }}
              >
                <Form.Control size="lg" required placeholder="Name" name="Name" value={hireTopLevelTalentData.Name} onChange={handleChange} />
                <Form.Control.Feedback type="invalid" >
                  {" "}
                  Please provide a Name.
                </Form.Control.Feedback>
              </Col>
              <Col
                xs={12}
                sm={12}
                md={12}
                lg={6}
                style={{ marginBottom: "20px" }}
              >
                <Form.Control size="lg" required placeholder="Email ID"  name="Email" value={hireTopLevelTalentData.Email} onChange={handleChange}/>
                <Form.Control.Feedback type="invalid">
                  {" "}
                  Please provide a Email.
                </Form.Control.Feedback>
              </Col>
              <Col
                xs={12}
                sm={12}
                md={12}
                lg={6}
                style={{ marginBottom: "20px" }}
              >
                <Form.Control size="lg" required placeholder="Job Title"  name="JobTitle" value={hireTopLevelTalentData.JobTitle} onChange={handleChange} />
                <Form.Control.Feedback type="invalid">
                  {" "}
                  Please provide a Job Title.
                </Form.Control.Feedback>
              </Col>
              <Col
                xs={12}
                sm={12}
                md={12}
                lg={6}
                style={{ marginBottom: "20px" }}
              >
                <Form.Control size="lg" required placeholder="Phone Number" name="Phone" value={hireTopLevelTalentData.Phone} onChange={handleChange}/>
                <Form.Control.Feedback type="invalid" >
                  {" "}
                  Please provide a Phone Number.
                </Form.Control.Feedback>
              </Col>
              <Col xs={12} sm={12} md={12} lg={12} style={colstyle}>
                <Form.Group className="mb-3">
                  <Form.Control
                    as="textarea"
                    rows={5}
                    required
                    placeholder="How can we help you today?"
                    name="Description" value={hireTopLevelTalentData.Description} onChange={handleChange}
                  />
                  <Form.Control.Feedback type="invalid" >
                    {" "}
                    Please provide a Contents
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Col style={Buttoncolstyle}>
              <Button
              // className='animated-imaget'
                type="submit"
                size="lg"
                style={buttonStyle}
                onMouseOver={handleMouseOver}
                onMouseOut={handleMouseOut}
              >
                &nbsp;&nbsp; Request A Call Back &nbsp;&nbsp;{" "}
                <span style={{ fontSize: "20px" }}>
                  {" "}
                  <GoChevronRight />{" "}
                </span>{" "}
                &nbsp;&nbsp;
              </Button>
              <ToastContainer />
            </Col>
          </Col>
        </Form>
      </div>
    </Container>
  );
}

export default Lookingtohire;
